/**
 * DeliverView - Wrapper for the Deliver section with sub-tabs.
 * 
 * Tabs:
 *   "Runs"         → existing MapView (route planning & dispatch)
 *   "Delivery Log"  → chronological feed of completed deliveries
 */
import React, { useState } from 'react';
import { Map, ClipboardCheck } from 'lucide-react';
import MapView from './MapView';
import DeliveryLogView from './DeliveryLogView';
import OfflineInfoBar from '@/components/OfflineInfoBar';

const TABS = [
  { id: 'runs', label: 'Runs', icon: Map },
  { id: 'log', label: 'Delivery Log', icon: ClipboardCheck },
];

export default function DeliverView() {
  const [activeTab, setActiveTab] = useState('runs');

  return (
    <div className="h-[calc(100vh-56px)] flex flex-col" data-testid="deliver-view">
      <OfflineInfoBar />
      {/* Sub-tab bar */}
      <div className="flex items-center gap-1 px-3 py-1.5 bg-white border-b border-stone-200 flex-shrink-0">
        {TABS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            onClick={() => setActiveTab(id)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
              activeTab === id
                ? 'bg-primary/10 text-primary'
                : 'text-stone-500 hover:bg-stone-100 hover:text-stone-700'
            }`}
            data-testid={`deliver-tab-${id}`}
          >
            <Icon className="h-3.5 w-3.5" />
            {label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="flex-1 min-h-0">
        {activeTab === 'runs' ? <MapView /> : <DeliveryLogView />}
      </div>
    </div>
  );
}
